import workerChannel from "./worker.channel";
import { put, take } from "typed-redux-saga";
import { workerActions } from "../../reducers/worker.slice";

function* linearRegressionWorkerSaga() {
  const webWorker = new Worker(
    new URL("../workers/linear-regression.worker.js", import.meta.url)
  );

  const channel = workerChannel(webWorker);

  while (true) {
    try {
      const action = yield* take(workerActions.linearRegression);
      webWorker.postMessage(action.payload);

      const data = (yield* take(channel)) as {
        key: string;
        coefOfDetermination: number;
      };

      yield* put(
        workerActions.setLinearRegression({
          key: action.payload.key,
          coefOfDetermination: data.coefOfDetermination,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}

export default linearRegressionWorkerSaga;
